import { GeneralCalculationState } from "./generalCalculation";
import { imperialState, metricState } from "@reducers/selectors/dimension";
import { APP_TYPES } from "@config";
import { mergeDeep } from "@services/helper.service";

export const BracketAttachmentState = GeneralCalculationState;

export function getBracketAttachmentDefault(isImperial) {
    let unitState = isImperial ? imperialState[APP_TYPES.BRACKET_ATTACHMENT] : metricState[APP_TYPES.BRACKET_ATTACHMENT];
    return mergeDeep({}, BracketAttachmentState, { 
        padding: {
          // For square
          s1: unitState.basePlate.spacing.s1,
          s2: unitState.basePlate.spacing.s2,
        }
    });
}



// WEBPACK FOOTER //
// ./src/reducers/options/screw/defaults/bracketAttachment.js